import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { PerformanceRecord } from '@/types/performanceRecord';

export const getPerformanceRecords = async (
  childID: number
): Promise<ApiResult<PerformanceRecord[]>> => {
  const { status, result } = await callApi<PerformanceRecord[]>(
    `children/${childID}/performance-records`,
    'GET',
    undefined,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
